module.exports = __webpack_public_path__ + "media/42_Long.b242e823.mp3";